"use client";
import { QuickLinksType } from "@/common/lib/types";
import React, { useMemo } from "react";
import { CLink } from "../common/customLink/CustomLink";
import { useParams, usePathname } from "next/navigation";
import { cn } from "@/lib/tailwind";
import { hasArrayElements } from "@/apiUtils/commonUtils";

interface IProps {
  quickLinks: QuickLinksType;
  containerClass?: string;
}
const StaticNavbarSection = ({ quickLinks, containerClass }: IProps) => {
  const pathname = usePathname();
  const isActiveUrl = (url: string) => Boolean(pathname.includes(url));
  // console.log({ quickLinks });
  return hasArrayElements(quickLinks?.items) ? (
    <section className={cn("lg:px-0", containerClass)}>
      <div className="flex w-full justify-center border-b border-tertiary-3">
        <ul
          className={cn(
            "no-scrollbar container flex h-[60px] w-full items-center justify-start overflow-auto bg-white py-0 text-center sm:justify-center",
            quickLinks?.items?.length > 5 ? "sm:justify-start lg:justify-center" : "",
          )}
        >
          {quickLinks?.items?.map((item) =>
            item?.url?.url ? (
              <li
                key={item?.url.url}
                className={cn(
                  "flex h-full",
                  isActiveUrl(item?.url?.url) ? "border-b-2 border-black" : "",
                )}
              >
                <CLink
                  href={item?.url?.url}
                  className="mx-4 flex h-full cursor-pointer items-center whitespace-nowrap text-sm font-semibold hover:text-gray-800"
                >
                  {item?.name}
                </CLink>
              </li>
            ) : (
              ""
            ),
          )}
        </ul>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default StaticNavbarSection;
